class MobileMenu extends HTMLElement {
  links; bar; results; filters;

  static selectors = {
    link: '[data-menu-link]',
    bar: '[data-menu-search]',
    filter: '[data-filter]',
    results: '[data-menu-result]'
  };

  constructor() {
    super();
    this.init();
  }

  init = () => {
    this.links = this.querySelectorAll(MobileMenu.selectors.link);
    this.bar = this.querySelector(MobileMenu.selectors.bar);
    this.results = this.querySelectorAll(MobileMenu.selectors.results);
    this.filters = this.querySelectorAll(MobileMenu.selectors.filter);

    this.links.forEach((link) => {
      link.addEventListener('click', (e) => {
        this.clickLink(e, link);
      });
    });

    this.filters.forEach((letter) => {
      letter.addEventListener('click', (e) => {
        this.alphabet(e, letter.dataset.filter);
      });
    });

    if(this.bar != null){
      this.bar.addEventListener('keyup', (e) => {
        this.search(this.bar.value);
      });
    }
  }

  clickLink = (e, el) => {
    e.preventDefault();
    const link = document.querySelector(el.getAttribute('href'));
    if(link != undefined){
      this.close();
      link.open();
    }
  }

  alphabet = (e, letter) => {
    e.preventDefault();
    letter = letter.toUpperCase();
    for(var i=0;i<this.results.length;i++){
      const l = this.results[i].dataset.menuResult.toUpperCase().charAt(0);
      if(l.localeCompare(letter) == 0){
        this.scrollTop = this.results[i].offsetTop;
        break;
      }
    }
  }

  search = (key) => {
    key = key.toLowerCase().trim();
    if(key.length > 0){
      this.hideAllResults();
      const results = Array.from(this.results).filter((link) => {
        const value = link.dataset.menuResult.toLowerCase();
        return value.indexOf(key) !== -1;
      });
      results.forEach((link) => {
        link.classList.remove('d-none');
      })
    } else {
      this.showAllResults();
    }
  }

  showAllResults = () => {
    this.results.forEach((link) => {
      link.classList.remove('d-none');
    });
  }

  hideAllResults = () => {
    this.results.forEach((link) => {
      link.classList.add('d-none');
    });
  }

  open = () => {
    this.classList.remove('closed');
  }

  close = () => {
    this.classList.add('closed');
  }
}
if (!window.customElements.get("mobile-menu")) {
  window.customElements.define("mobile-menu", MobileMenu);
}